import React from "react";
import {
  AddHospitalWrapper,
  DropdownWrapper,
  RightOverlay,
  Wrapper,
} from "./index.styled";
import HospitalComparisonDropdown from "../HospitalComparisonDropdown";
import CategoriesSearchBox from "../CategoriesSearchBox";
import { useDispatch, useSelector } from "react-redux";
import {
  addNewHospital,
  removeHospitalFromCompare,
  updateHospitalInCompare,
} from "../../Redux/compare/compare.actions";
import { useSnack } from "../SnackBar";
import { AddHospitalDiv, AddHospitalText } from "../HospitalComparisonDropdown/index.sc";
import { ReactComponent as AddHospitalCompareIcon } from "../../Assets/Icons/AddHospitalCompareIcon.svg";
import SpacerWithButton from "./SpacerWithButton";
import { AnimatePresence } from "framer-motion";

const HospitalFilterMenu = ({
  searchParams,
  options,
  selectedOption = [],
  setSelectedOption = () => {},
  hospitalsData,
  scrollRef,
  onScroll,
  showGradient,
}) => {
  const { compareHospitals } = useSelector((state) => state.compare);
  const dispatch = useDispatch();
  const snack = useSnack();

  const handleDropdownChange = (newSelection, index) => {
    const isAlreadySelected = compareHospitals.some(
      (hospital) => hospital.provider_number === newSelection.provider_number,
    );

    if (isAlreadySelected) {
        snack(
          "Looks like this hospital is already in the list",
          "#FFC640",
          "#333333"
        );
        return;
      }
    dispatch(updateHospitalInCompare(newSelection, index));
  };

  const addEmptyHospital = (index) => {
    if (compareHospitals.length >= 20) {
      snack(
        "Max Selection reached! Up to 20 Hospitals can be compared",
        "#FFC640",
        "#333333"
      );
      return;
    }
    dispatch(addNewHospital(index));
  };

  const removeHospital = (index) => {
    const hospitalToRemove = compareHospitals[index];
    dispatch(removeHospitalFromCompare(hospitalToRemove.provider_number));
  };

  const getFilteredOptions = () => {
    return options.filter(
      (option) =>
        !selectedOption.some(
          (selected) =>
            selected && selected.provider_number === option.provider_number,
        ),
    );
  };

  const filteredOptions = getFilteredOptions();

  const hasEmptyObject = () => {
    return compareHospitals.some((option) => Object.keys(option).length === 0);
  };

  return (
    <Wrapper showGradient={showGradient}>
      <CategoriesSearchBox
        searchParams={searchParams}
        placeholder="Search Categories"
        hospitalsData={hospitalsData}
      />
      <DropdownWrapper ref={scrollRef} onScroll={onScroll}>
        {/* <AnimatePresence mode="popLayout"> */}
          {compareHospitals.map((hospital, index) => {
            const hospitalDetails = hospitalsData?.find(
              (item) =>
                String(item?.provider_number) === String(hospital?.provider_number)
            );

            const hospitalWithEsa = Object.keys(hospital).length === 0? hospital: {
                ...hospital,
                esa: hospitalDetails?.esa,
              };

            return (
              <React.Fragment key={hospital.provider_number || index}>
                {index === 0 && (
                  <SpacerWithButton
                    onClick={() => addEmptyHospital(index)}
                  />
                )}

                <HospitalComparisonDropdown
                  key={hospital.provider_number || index}
                  setSelectedOption={(newSelection) => {
                    handleDropdownChange(newSelection, index);
                  }}
                  options={filteredOptions}
                  selectedOption={hospitalWithEsa}
                  removeHospital={() => removeHospital(index)}
                />

                {index < compareHospitals.length - 1 && (
                  <SpacerWithButton
                    onClick={() => addEmptyHospital(index + 1)}
                  />
                )}
              </React.Fragment>
            );
          })}
          {!hasEmptyObject() && (compareHospitals.length < 20) && (
            <AddHospitalWrapper
              onClick={() => addEmptyHospital(compareHospitals.length)} isEmpty={compareHospitals.length === 0}
              layout
              initial={{ opacity: 1, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{
                type: "spring",
                stiffness: 300,
                damping: 25,
              }}
            >
              <AddHospitalDiv isScrollActive={compareHospitals.length >= 3}>
                <AddHospitalText animate={true}>
                  <AddHospitalCompareIcon /> Add Hospital
                </AddHospitalText>
              </AddHospitalDiv>
            </AddHospitalWrapper>
          )}
        {/* </AnimatePresence> */}
      </DropdownWrapper>
    </Wrapper>
  );
};

export default HospitalFilterMenu;
